import type { InputParams, ITpaasEvent } from '@schibsted/pulse-sdk';
import type { ByfunnPulseContextProviderConfig } from '../../types.js';

export const buildProviderInput = (
  pulseConfig: ByfunnPulseContextProviderConfig,
): InputParams<ITpaasEvent>['provider'] => ({
  stage: pulseConfig.stage,
  product: pulseConfig.product,
});
